module.exports = __webpack_public_path__ + "static/media/next-js.a2eb27e8.svg";